import { useQuery } from '@tanstack/react-query';

import { dashboardOptions } from './dashboard.options';

export const useDashboard = (enabled = true) => {
  return useQuery({ ...dashboardOptions.list(), enabled });
};

export const useSharedDashboard = (shareToken: string | null) => {
  return useQuery(dashboardOptions.shared(shareToken));
};

export type { MarketApps } from '@/features/dashboard/types';
